import { render } from "./FileText.vue?vue&type=template&id=7423d557"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FileText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7423d557"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7423d557', __exports__)) {
    api.reload('7423d557', __exports__)
  }
  
  module.hot.accept("./FileText.vue?vue&type=template&id=7423d557", () => {
    api.rerender('7423d557', render)
  })

}


export default __exports__